var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { editJobComment, getJobCommentReplies } from '@/api';
import { useMutation } from '@/hooks';
import { useQuery } from '@/hooks/use-query';
import { convertUTCDateToLocalDate, fromNow } from '@/utils';
import { CloseWithoutOutline, DeleteIcon, EditIcon, SendIcon } from '../icons';
import { JobPostLikeBox } from '../job-card';
import { JobCommentSkeletonList } from '../skeleton/job-comment-list-skeleton';
import { Avatar } from './avatar';
import { Button } from './button';
import { StyledTextField } from './styles-text-input';
import { Text } from './text';
export var JobCommentSection = function (_a) {
    var comment = _a.comment, likeJobCommentMutation = _a.likeJobCommentMutation, deleteJobCommentMutation = _a.deleteJobCommentMutation, _b = _a.replySectionMargin, replySectionMargin = _b === void 0 ? 'ml-8' : _b, onReplyClick = _a.onReplyClick, setJobComments = _a.setJobComments, addJobCommentMutation = _a.addJobCommentMutation, setReplyComments = _a.setReplyComments;
    var _c = useState(false), showReply = _c[0], setShowReply = _c[1];
    var _d = useState(false), showReplyForm = _d[0], setShowReplyForm = _d[1];
    var _e = useState(''), replyText = _e[0], setReplyText = _e[1];
    var _f = useState(false), isEditing = _f[0], setIsEditing = _f[1];
    var _g = useState(comment.comment), editedComment = _g[0], setEditedComment = _g[1];
    var editJobCommentMutation = useMutation({
        mutationFn: editJobComment,
        onSuccess: function (response, payload) {
            setEditedComment(payload.comment);
            setIsEditing(false);
            if (comment.is_replied_comment) {
                setReplyComments === null || setReplyComments === void 0 ? void 0 : setReplyComments(function (prevComments) {
                    if (!prevComments)
                        return prevComments;
                    return prevComments.map(function (c) {
                        if (c.job_comment_id === comment.job_comment_id) {
                            return __assign(__assign({}, c), { comment: payload.comment });
                        }
                        return c;
                    });
                });
            }
            else {
                setJobComments === null || setJobComments === void 0 ? void 0 : setJobComments(function (prevComments) {
                    if (!prevComments)
                        return prevComments;
                    return prevComments.map(function (c) {
                        if (c.job_comment_id === comment.job_comment_id) {
                            return __assign(__assign({}, c), { comment: payload.comment });
                        }
                        return c;
                    });
                });
            }
        },
    }).mutate;
    var handleReplyCommentClick = useCallback(function () {
        if (comment.is_replied_comment) {
            // For child comments, trigger the parent's reply form
            onReplyClick === null || onReplyClick === void 0 ? void 0 : onReplyClick();
        }
        else {
            // For main comments, show the reply section
            setShowReply(true);
            setShowReplyForm(true);
            setReplyText('');
        }
    }, [onReplyClick, comment.is_replied_comment]);
    return (_jsxs("div", { className: 'flex flex-col gap-2 pb-2', children: [_jsxs("div", { className: 'flex gap-2', children: [_jsx(Avatar, { name: [comment.first_name, comment.last_name].join(' '), size: 30, src: comment.profile_pic_url }), _jsx(Text, { className: 'font-medium', children: [comment.first_name, comment.last_name].join(' ') }), comment.comment_by_current_user && (_jsxs(_Fragment, { children: [_jsx(Button, { variant: 'dangerSecondary', size: 'sm', className: 'rounded-md', title: 'Delete Comment', onClick: function () {
                                    deleteJobCommentMutation(comment.job_comment_id, {
                                        onSuccess: function () {
                                            if (comment.is_replied_comment) {
                                                setReplyComments === null || setReplyComments === void 0 ? void 0 : setReplyComments(function (prevComments) {
                                                    if (!prevComments)
                                                        return prevComments;
                                                    return prevComments.filter(function (c) { return c.job_comment_id !== comment.job_comment_id; });
                                                });
                                                setJobComments === null || setJobComments === void 0 ? void 0 : setJobComments(function (prevComments) {
                                                    if (!prevComments)
                                                        return prevComments;
                                                    return prevComments.map(function (c) {
                                                        if (c.job_comment_id === comment.main_comment_id) {
                                                            return __assign(__assign({}, c), { replied_count: c.replied_count ? c.replied_count - 1 : 0 });
                                                        }
                                                        return c;
                                                    });
                                                });
                                            }
                                        },
                                    });
                                }, children: _jsx(DeleteIcon, {}) }), _jsx(Button, { variant: 'primary', size: 'sm', className: 'rounded-md', title: 'Edit Comment', onClick: function () {
                                    setIsEditing(true);
                                }, children: _jsx(EditIcon, {}) })] }))] }), isEditing ? (_jsxs("form", { className: 'flex gap-2 items-end', onSubmit: function (e) {
                    e.preventDefault();
                    editJobCommentMutation({
                        commentId: comment.job_comment_id,
                        comment: editedComment,
                    });
                }, children: [_jsx(StyledTextField, { value: editedComment, onChange: function (e) {
                            setEditedComment(e.target.value);
                        } }), _jsx(Button, { variant: 'secondary', className: 'rounded-md px-2', onClick: function () {
                            setIsEditing(false);
                        }, children: _jsx(CloseWithoutOutline, { className: 'size-4' }) }), _jsx(Button, { variant: 'primary', type: 'submit', className: 'rounded-md px-2', disabled: editedComment === comment.comment, children: _jsx(SendIcon, {}) })] })) : (_jsx(Text, { variant: 'description', children: comment.comment })), _jsxs("div", { className: 'flex gap-2 items-center text-gray-600 text-xs', children: [_jsx(JobPostLikeBox, { jobLikedByCurrentUser: comment.comment_liked_by_current_user, likesCount: comment.liked_count || 0, jobId: comment.job_id, handleLikedPeople: function () {
                            return;
                        }, setShowLikedPeople: function () {
                            return;
                        }, handleLikeJob: function (status) {
                            likeJobCommentMutation({
                                commentId: comment.job_comment_id,
                                liked: status,
                                mainCommentId: comment.main_comment_id,
                            }, {
                                onSuccess: function (response, payload) {
                                    if (comment.is_replied_comment) {
                                        setReplyComments === null || setReplyComments === void 0 ? void 0 : setReplyComments(function (prevComments) {
                                            if (!prevComments)
                                                return prevComments;
                                            return prevComments.map(function (comment) {
                                                if (comment.job_comment_id === payload.commentId) {
                                                    return __assign(__assign({}, comment), { liked_count: payload.liked
                                                            ? comment.liked_count + 1
                                                            : comment.liked_count - 1, comment_liked_by_current_user: payload.liked });
                                                }
                                                return comment;
                                            });
                                        });
                                    }
                                },
                            });
                        } }), _jsxs(Button, { variant: 'text', className: 'rounded-md px-0 py-0 flex gap-2 font-medium text-gray-800', onClick: handleReplyCommentClick, children: ["Replay", !comment.is_replied_comment && (_jsx("span", { className: 'bg-gray-200 rounded-md px-2 py-1', children: comment.replied_count || 0 }))] }), fromNow(convertUTCDateToLocalDate(comment.created_date)), comment.is_edited && ' (edited)'] }), showReply && !comment.is_replied_comment && (_jsx("div", { className: "flex flex-col gap-2 ".concat(replySectionMargin), children: _jsx(JobCommentReply, { likeJobCommentMutation: likeJobCommentMutation, deleteJobCommentMutation: deleteJobCommentMutation, jobId: comment.job_id, comment: comment, onReplyClick: handleReplyCommentClick, setJobComments: setJobComments, addJobCommentMutation: addJobCommentMutation, replyText: replyText, setReplyText: setReplyText, showReplyForm: showReplyForm, setShowReplyForm: setShowReplyForm }) }))] }));
};
var JobCommentReply = function (_a) {
    var comment = _a.comment, jobId = _a.jobId, likeJobCommentMutation = _a.likeJobCommentMutation, deleteJobCommentMutation = _a.deleteJobCommentMutation, onReplyClick = _a.onReplyClick, setJobComments = _a.setJobComments, addJobCommentMutation = _a.addJobCommentMutation, replyText = _a.replyText, setReplyText = _a.setReplyText, showReplyForm = _a.showReplyForm, setShowReplyForm = _a.setShowReplyForm;
    var queryFnToGetAllJobComments = useCallback(function () { return getJobCommentReplies(jobId, comment.job_comment_id); }, [comment.job_comment_id, jobId]);
    var _b = useQuery({
        queryFn: queryFnToGetAllJobComments,
        config: {
            enabled: !!comment.replied_count,
        },
    }), comments = _b.data, setComments = _b.setData, isJobCommentLoading = _b.isLoading;
    if (isJobCommentLoading) {
        return _jsx(JobCommentSkeletonList, { count: 2 });
    }
    return (_jsxs(_Fragment, { children: [comments === null || comments === void 0 ? void 0 : comments.map(function (comment) { return (_jsx(JobCommentSection, { comment: comment, likeJobCommentMutation: likeJobCommentMutation, deleteJobCommentMutation: deleteJobCommentMutation, replySectionMargin: 'ml-0', onReplyClick: onReplyClick, setJobComments: setJobComments, addJobCommentMutation: addJobCommentMutation, setReplyComments: setComments }, comment.job_comment_id)); }), showReplyForm && (_jsxs("form", { className: 'flex gap-2 items-end', onSubmit: function (e) {
                    e.preventDefault();
                    addJobCommentMutation({
                        jobId: comment.job_id,
                        comment: replyText,
                        repliedToCommentId: comment.job_comment_id,
                    }, {
                        onSuccess: function (response) {
                            setComments === null || setComments === void 0 ? void 0 : setComments(function (prevComments) { return __spreadArray(__spreadArray([], (prevComments || []), true), (response || []), true); });
                            setReplyText('');
                        },
                    });
                }, children: [_jsx(StyledTextField, { value: replyText, onChange: function (e) {
                            setReplyText(e.target.value);
                        }, placeholder: 'Add a reply...' }), _jsx(Button, { variant: 'secondary', className: 'rounded-md px-2', onClick: function () {
                            setShowReplyForm(false);
                        }, children: _jsx(CloseWithoutOutline, { className: 'size-4' }) }), _jsx(Button, { variant: 'primary', type: 'submit', className: 'rounded-md px-2', disabled: !replyText.trim(), children: _jsx(SendIcon, {}) })] }))] }));
};
